/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import { GET_BOXES } from "../graphql/getBoxes.query";
const { toHeaderCase } = require("js-convert-case");

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface IgetBoxesMethods extends IPluginMethodMap {
  getBoxes(): Promise<any>;
}

export class getBoxesService implements IAgentPlugin {
  readonly methods: IgetBoxesMethods;

  constructor() {
    this.methods = {
      getBoxes: this.getBoxes.bind(this),
    };
  }

  async getBoxes() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const srv = getAppNavService();

    try {
      if (client) {
        const data = await srv?.getMyProfile();

        if (data?.userId && is.existy(data?.userId)) {
          const res = await client.query({
            query: GET_BOXES,
            variables: {
              filter: {
                user: {
                  eq: data?.userId,
                },
              },
            },
            fetchPolicy: "network-only",
          });
          let box = false;
          if (res?.data?.getBoxes) {
            box = res?.data?.getBoxes?.content.length > 0 ? true : false;
            console.log("box==>", box);
            return box;
          }
          return box;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
